<script>
import ECharts from "vue-echarts";
import "echarts/lib/chart/line";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/pie";
import "echarts/lib/chart/scatter";
import "echarts/lib/chart/candlestick";
import "echarts/lib/chart/gauge";

import "echarts/lib/component/legend";
import "echarts/lib/component/title";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/polar";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/grid";
import "echarts/lib/component/axis";
import appConfig from "@/app.config";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";

export default {
  mixins: [Api, Sabit],
  props: ["Data"],
  page: {
    title: "Anket Oluştur",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { "v-chart": ECharts },
  data() {
    return {
      pieChart: {
        visualMap: {
          show: false,
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} ",
          //: {c} ({d}%)
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: ["Laptop", "Tablet", "Mobile", "Others", "Desktop"],
          textStyle: {
            color: "#999",
          },
        },
        color: ["#5cc8f2", "#f2bb07", "#f28907", "#f26938", "#f23005", "#d92938", "#6f7302", "#d97c2b", "#8c8c8c", "#595959"],
        series: [
          {
            name: "Oran",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: [],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      },
    };
  },
  methods: {
    Get() {},
  },
  created() {
    this.pieChart.series[0].data = [];
    for (var i = 0; i < this.Data.length; i++) {
      this.pieChart.series[0].data.push(this.Data[i]);
    }
  },
  watch: {
    Data() {
      this.pieChart.series[0].data = [];
      for (var i = 0; i < this.Data.length; i++) {
        if (this.Data[i].value != 0) {
          this.pieChart.series[0].data.push(this.Data[i]);
        }
      }
    },
  },
};
</script>

<template>
  <div >
    <v-chart :options="pieChart" autoresize style="margin-left: -125px;"/>

    <div class="row">
      <div class="col-4" v-for="(DataLabel, index) in Data" :key="index">
        <b-form-group class="mb-3" label-cols-sm="8" label-cols-lg="8" :label="DataLabel.namefooter" label-for="color">
          <b-form-input style="width: 40px;" class="form-control-color mw-100" id="color" type="color" name="color" v-model="pieChart.color[index]"></b-form-input>
        </b-form-group>
      </div>
    </div>
  </div>
</template>
